// K2-3072: what the storefront does with vuestorefront-api's answer to an OTP
// (2DS) confirmation.

export type OtpOutcome = 'paid' | 'pending' | 'wrong_code' | 'failed'

// K2-3084: a refusal that only means the order's payment is being checked
// (e.g. another charge of the order may have taken the money).
const PENDING_REASONS = ['payment_being_checked', 'payment_in_progress', 'payment_pending']

/**
 * paid: settled (200). pending: not settled but possibly charged (202, a
 * being-checked reason, or no answer at all) - shown as being checked and
 * never reported as failed. wrong_code: iPay refused the code. failed: a
 * decline or any other refusal.
 */
export function otpVerificationOutcome (resp: any): OtpOutcome {
  if (!resp || typeof resp !== 'object') {
    return 'pending'
  }
  if (resp.code === 200) {
    return 'paid'
  }
  if (resp.code === 202 || PENDING_REASONS.includes(resp.reason)) {
    return 'pending'
  }
  if (resp.result === 'invalid value') {
    return 'wrong_code'
  }
  return 'failed'
}

interface OtpVerificationHost {
  otpVerifying: boolean,
  $bus: { $emit (event: string, payload?: any): void }
}

/**
 * K2-3073: runs one OTP confirmation with the loader on, stopped on every exit.
 * A submit while one is in flight is ignored (resolves undefined, verify not called).
 */
export async function runOtpVerification<T> (host: OtpVerificationHost, loaderText: string, verify: () => Promise<T>): Promise<T | undefined> {
  if (host.otpVerifying) {
    return undefined
  }
  host.otpVerifying = true
  host.$bus.$emit('notification-progress-start', loaderText)
  try {
    return await verify()
  } finally {
    host.otpVerifying = false
    host.$bus.$emit('notification-progress-stop', {})
  }
}
